import styled from "styled-components";

export const EnvCard = styled.div`
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 2px 5px hsla(0,0%,53.3%,.49019607843137253);
  margin-bottom: 30px;
`;

export const EnvHeader = styled.header`
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 10px;
  border-bottom: 2px solid ${props => props.theme.textColor};
  border-radius: 20px 20px 0 0;
`;
